import React from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorCodes } from '../../utils/errorCodes';
import { formatFrontendSupportError } from '../../utils/frontendErrorFormat';
import Content from '../../components/Content';
import PageStyles from './404Page.module.css';

const FRONTEND_404_ERROR_CODE = ErrorCodes.RESOURCE_NOT_FOUND;

const buildNotFoundSupportError = (pathName) =>
	formatFrontendSupportError({
		errorCode: FRONTEND_404_ERROR_CODE,
		pageInfo: `404 Page / Route Not Found (${pathName})`,
		sourceMessage: '',
	});

const NotFound = () => {
	const location = useLocation();
	const [copied, setCopied] = React.useState(false);

	const requestedPath = `${location?.pathname || '/'}${location?.search || ''}${location?.hash || ''}`;
	const supportError = buildNotFoundSupportError(requestedPath);

	const handleCopyDetails = async () => {
		try {
			await navigator.clipboard.writeText(supportError);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (error) {
			setCopied(false);
		}
	};

	return (
		<div className={PageStyles.maincontent}>
			<Content currentMenu='notfound'>
				<div className={PageStyles.content}>
					<h1>404</h1>
					<h3>Page Not Found</h3>
					<p>Sorry, the page you are looking for could not be found.</p>
					<p className={PageStyles.pathInfo}>Requested Path: {requestedPath}</p>
					<div className={PageStyles.errorBox}>
						<strong>Support Error:</strong>
						<code className={PageStyles.errorCode}>{supportError}</code>
					</div>
					<button
						type='button'
						className={PageStyles.copyButton}
						onClick={handleCopyDetails}
					>
						{copied ? 'Copied' : 'Copy Error Details'}
					</button>
					<img src='/assets/404-image.png' alt='404 Not found' />
				</div>
			</Content>
		</div>
	);
};

export default NotFound;
